import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { withRouter } from 'react-router-dom';

import { usePage } from '@ezbobdev/ui-commons';

const MaterialPage = (props) => {
  const { children, location, beforeRender, afterRender } = props;
  const { wrapperClasses } = usePage(props);

  return useMemo(
    () => (
      <div className={wrapperClasses}>
        {beforeRender ? <div className="beforeRender">{beforeRender}</div> : undefined}
        {children}
        {afterRender ? <div className="afterRender">{afterRender}</div> : undefined}
      </div>
    ),
    [wrapperClasses, children, location, beforeRender],
  );
};

MaterialPage.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  pageName: PropTypes.string.isRequired,
  didMount: PropTypes.func,
  beforeRender: PropTypes.node,
  afterRender: PropTypes.node,
};

export default withRouter(React.memo(MaterialPage));
